import BasePage from "@DigitalCatalogue/Scripts/Pages/BasePage";
import { Fancybox } from "@fancyapps/ui";

export default class TextureDetailPage extends BasePage {
    public static async init() {
        await super.init();

        this.setGallery();
        this.setDialogDownload();
    }

    public static setGallery() {
        Fancybox.bind("[data-fancybox='gallery']", {
            dragToClose: false,
            Images: {
                zoom: false,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            }
        });
    }
    public static setDialogDownload() {
        let adviceProdDialogs = document.querySelectorAll(".button[data-download]");
        for (const item of adviceProdDialogs) {
            item.addEventListener("click", x => {
                document.querySelector(".dialog").classList.add("show");
            }, false);
        }

        let closeButtons = document.querySelectorAll(".dialog[data-download] > .wrapper > .close");
        for (const item of closeButtons) {
            item.addEventListener("click", x => {
                document.querySelector(".dialog").classList.remove("show");
            }, false);
        }
    }
}